module.exports = __webpack_public_path__ + "static/img/item03.6b709f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item03.png
// module id = K2mV
// module chunks = 0